'use client';

import DallasSvgIconFolderSharedOutlined from '@ui/Dallas/Icons/DallasSvgIconFolderSharedOutlined';
import NavLink from '../../../../_ui/NavItems/NavLink';
import useIsActivePathname from '../../../../_lib/useIsActivePath';
import { BROKER_DIRECTORY_PAGE_PATH } from '../../../../../pages';

export default function BrokerDirectoryNavLink() {
  return (
    <NavLink
      href={BROKER_DIRECTORY_PAGE_PATH}
      label="Broker Directory"
      icon={<DallasSvgIconFolderSharedOutlined />}
      active={useIsActivePathname(BROKER_DIRECTORY_PAGE_PATH, {
        match: 'startsWith',
      })}
    />
  );
}
